import {
  InfoOutlineIcon,
  MouseCursorIcon,
  NoticeOutlineIcon,
  StopIcon,
} from '@carboncopyco/icons';
import {
  DropdownItem,
  TextBase,
  TextButton,
  TextCaption,
  Tooltip,
  TooltipMessage,
} from '@carboncopyco/ui';
import { useRef } from 'react';

export const TextExtractionCapturing = ({
  isTextExtractionStarted,
  onTextExtractionItemClick,
}: {
  isTextExtractionStarted: boolean;
  onTextExtractionItemClick: (val: boolean) => void;
}) => {
  const handleTextExtractionItemClick = () => {
    onTextExtractionItemClick(!isTextExtractionStarted);
  };

  const dropdownItemRef = useRef(null);

  return (
    <>
      <div ref={dropdownItemRef}>
        <DropdownItem
          label={
            <TextBase
              label={
                isTextExtractionStarted
                  ? 'Stop capturing'
                  : 'Start capture text'
              }
              color="text-ds-natural-600"
            />
          }
          iconLeft={
            isTextExtractionStarted ? (
              <StopIcon size={20} />
            ) : (
              <MouseCursorIcon size={20} />
            )
          }
          iconRight={<InfoOutlineIcon size={20} />}
          onClick={handleTextExtractionItemClick}
        />
      </div>
      <Tooltip
        anchorRef={dropdownItemRef}
        placement="bottom"
        noArrow
      >
        <TooltipMessage
          title={
            <div className="flex items-center gap-1">
              <NoticeOutlineIcon size={16} />
              <TextButton
                label="Text export into spreadsheet"
                color="text-ds-natural-600"
              />
            </div>
          }
          message={
            <div className="w-96">
              <TextCaption
                label={`To export text, click "Start capture text" to start capturing as you move through pages, then click again to stop.`}
              />
            </div>
          }
        />
      </Tooltip>
    </>
  );
};
